// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dx6ev","container__buttons":"styles_container__buttons__YGiJF","skeleton-animation":"styles_skeleton-animation__hx9q6"};